export const SameDate = (
  date1Str: string | null,
  date2Str: string | null
): boolean => {
  if (date1Str === null || date2Str === null) return false;

  const date1 = new Date(date1Str.replace(/-/g, '/'));
  const date2 = new Date(date2Str.replace(/-/g, '/'));

  if (!date1 || !date2) return false;

  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};
